import axios from '@/services/axios';
import { AxiosResponse } from 'axios';

import { ContentDetail } from '../type';

// 测试 id：1236312904439514408

export async function getContentDetail(id: string) {
    const res = await axios.get<ContentDetail>(
        '/feed/rest/api/v1/feed/detail',
        {
            params: {
                itemId: id,
            },
        }
    );

    return res.data;
}
